
import _ from 'underscore';
import $ from 'jquery';
import {getLogger} from 'loglevel';
import {checkRunSpeedPerformance} from '../utilities/performanceHelpers';
import {ARROW_CONFIG} from '../config/index';

var log = getLogger('UiKit');

export class RegisteredComponent {

  constructor(fn, options) {
    this.fn = fn;
    options = _.defaults(options || {}, {
      feature: null,
      defer: true,        // use _.defer to release js thread
      priority: true,     // create the component on document ready
      ajaxable: true,     // If the component can load in an ajaxWrapper
      sitecoreable: false, // if the component needs to run after placeholders are loaded
      delayLoading: false  // If the component will be loaded after load event is done
    });

    this.featureFlag = options.featureFlag;
    this.featureFlagOff = options.featureFlagOff;
    this.defer = options.defer;
    this.ajaxable = options.ajaxable;
    this.sitecoreable = options.sitecoreable;
    this.delayLoading = options.delayLoading;
    this.priority = this.delayLoading ? false : options.priority;
  }

  create($parent) {
    if (!this.checkFeatureFlag()) return;
    checkRunSpeedPerformance(
      'Component Create',
      ARROW_CONFIG.framesPerSecondMs[50],
      ARROW_CONFIG.framesPerSecondMs[50],
      this.fn,
      this
    )($parent);
  }

  /**
   * Checks to see whether a feature flag exists or is off
   * @returns {Boolean}
   */
  checkFeatureFlag() {
    if (this.featureFlag) {
      return this.featureFlagOff ? this.featureFlag.isOff() : this.featureFlag.isEnabled();
    }

    return true;
  }

}

export class ComponentsRegistry {

  constructor() {
    this.registry = [];
  }

  register(fn, options) {
    var component = new RegisteredComponent(fn, options);
    this.registry.push(component);
  }

  create(components, $parent) {
    _.each(components, (component) => {
      if (component.defer) {
        _.defer(component.create.bind(component, $parent));
      } else {
        component.create($parent);
      }
    });
    if (components && components.length) {
      log.debug('Components create:', components.length, $parent);
    }
  }

  createWithPriority($parent) {

    $( window ).load(() => {
      this.create(this.getDelayLoadingComponents(), $parent);
    });

    this.create(this.getPriorityComponents(), $parent);
    setTimeout(() => {
      this.create(this.getLowPriorityComponents(), $parent);
      }, 100);
  }

  getPriorityComponents() {
    return _.where(this.registry, { priority: true, delayLoading: false });
  }

  getLowPriorityComponents() {
    return _.where(this.registry, { priority: false, delayLoading: false });
  }

  getAjaxDelayLoadingComponents() {
    return _.where(this.registry, { ajaxable: true, delayLoading: true });
  }

  getDelayLoadingComponents() {
    return _.where(this.registry, { delayLoading: true });
  }

  createAjaxWithPriority($parent) {

    $( window ).load(() => {
      this.create(this.getDelayLoadingComponents(), $parent);
    });

    this.create(this.getAjaxPriorityComponents(), $parent);
    setTimeout(() => {
      this.create(this.getAjaxLowPriorityComponents(), $parent);
    }, 100);
  }

  getAjaxPriorityComponents() {
    return _.where(this.registry, { ajaxable: true, priority: true, delayLoading: false });
  }

  getAjaxLowPriorityComponents() {
    return _.where(this.registry, { ajaxable: true, priority: false, delayLoading: false });
  }

  createSitecoreWithPriority($parent) {
    this.create(this.getSitecorePriorityComponents(), $parent);
    setTimeout(() => {
      this.create(this.getSitecoreLowPriorityComponents(), $parent);
    }, 100);
  }

  getSitecorePriorityComponents() {
    return _.where(this.registry, { sitecoreable: true, priority: true });
  }

  getSitecoreLowPriorityComponents() {
    return _.where(this.registry, { sitecoreable: true, priority: false });
  }

}



// WEBPACK FOOTER //
// ./uikit/components/ComponentsRegistry.js